<template>
  <!-- Formulario -->
  <v-form ref="form" autocomplete="off">
    <v-row>
      <!--Descripción-->
      <v-col cols="12" sm="4" md="6">
        <v-text-field
          v-model="editedItem.Descripcion"
          label="Descripción:"
          hint="Digite Información"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          dense
          clearable
        >
        </v-text-field>
      </v-col>

      <!--Label-->
      <v-col cols="12" sm="4" md="6">
        <v-text-field
          v-model="editedItem.Label"
          label="Label:"
          hint="Digite Información"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          dense
          clearable
        >
        </v-text-field>
      </v-col>

      <!-- Codigo de Ayuda -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.CodigoAyuda"
          :items="ArrayCodigoAyuda"
          :item-title="
            (ArrayCodigoAyuda) =>
              ArrayCodigoAyuda.CodigoId + '-' + ArrayCodigoAyuda.Nombre
          "
          item-value="CodigoId"
          color="primary"
          label="Código de Ayuda: "
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Mensaje Error -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.MensajeError"
          :items="ArrayMensajeError"
          :item-title="
            (ArrayMensajeError) =>
              ArrayMensajeError.CodigoId + '-' + ArrayMensajeError.Nombre
          "
          item-value="CodigoId"
          color="primary"
          label="Mensaje Error:"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Naturaleza -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Naturaleza"
          :items="ArrayNaturaleza"
          :item-title="
            (ArrayNaturaleza) =>
              ArrayNaturaleza.Valor + '-' + ArrayNaturaleza.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Naturaleza:"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Longitud de campo -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.Tamano"
          label="Longitud de campo:"
          clearable
          dense
          maxlength="3"
          counter="3"
          type="tel"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Tamaño de campo-->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.TamanoCampo"
          label="Tamaño de campo:"
          clearable
          dense
          maxlength="3"
          counter="3"
          type="tel"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Obligatorio -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Obligatoriedad"
          :items="ArraySiNo"
          :item-title="
            (ArraySiNo) => ArraySiNo.Valor + '-' + ArraySiNo.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Campo Obligatorio:"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Tipo de campo -->
      <v-col cols="6" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Tipo"
          :items="ArrayTipo"
          :item-title="
            (ArrayTipo) => ArrayTipo.Valor + '-' + ArrayTipo.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Tipo de campo:"
          dense
          @click="ChangeTipoDato()"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Tabla Valoración: -->
      <v-col
        v-if="editedItem.Tipo == 2 || editedItem.Tipo == 3"
        cols="12"
        sm="6"
        md="6"
      >
        <v-autocomplete
          v-model="editedItem.TablaValoracion"
          :items="ArrayTablaValoracion"
          color="primary"
          label="Tabla Valoración:"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Nombre API -->
      <v-col v-if="editedItem.Tipo == 4" cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.NombreAPI"
          label="Nombre API:"
          clearable
          dense
          maxlength="100"
          counter="100"
          type="text"
        >
        </v-text-field>
      </v-col>

      <!-- Número Predefinida -->
      <v-col v-if="editedItem.Tipo == 5" cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.NumeroPredefinida"
          :items="
            ArrayNumeroPredefinida.map((x) => ({
              ...x,
              Valor: Number(x.Valor),
            }))
          "
          :item-title="
            (ArrayNumeroPredefinida) =>
              ArrayNumeroPredefinida.Valor +
              '-' +
              ArrayNumeroPredefinida.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Número Predefinida:"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Número Constante: -->
      <v-col v-if="editedItem.Tipo == 8" cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.NumeroConstante"
          :items="ArrayNumeroConstante"
          :item-title="
            (ArrayNumeroConstante) =>
              ArrayNumeroConstante.Codigo +
              '-' +
              ArrayNumeroConstante.Descripcion
          "
          item-value="Codigo"
          color="primary"
          label="Número Constante:"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Número de Consecutivo: -->
      <v-col v-if="editedItem.Tipo == 6" cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.NumeroConsecutivo"
          :items="ArrayNumeroConsecutivo"
          :item-title="
            (ArrayNumeroConsecutivo) =>
              ArrayNumeroConsecutivo.ValorConsecutivo +
              '-' +
              ArrayNumeroConsecutivo.Descripcion
          "
          item-value="ValorConsecutivo"
          color="primary"
          label="Número de Consecutivo:"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Reporte -->
      <v-col v-if="editedItem.Tipo == 7" cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.ReporteID"
          :items="ArrayReporteID"
          :item-title="
            (ArrayReporteID) =>
              ArrayReporteID.ReporteID + '-' + ArrayReporteID.NombreReporte
          "
          item-value="ReporteID"
          color="primary"
          label="Reporte:"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Orden Reporte -->
      <v-col v-if="editedItem.Tipo == 7" cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.Orden"
          label="Orden Reporte:"
          clearable
          dense
          maxlength="3"
          counter="3"
          type="tel"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Grupo de Documentos -->
      <v-col v-if="editedItem.Tipo == 11" cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Grupo"
          :items="ArrayGrupo"
          :item-title="
            (ArrayGrupo) =>
              ArrayGrupo.GrpDocumentoID + '-' + ArrayGrupo.Descripcion
          "
          item-value="GrpDocumentoID"
          color="primary"
          label="Grupo de documentos:"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Documentos -->
      <v-col v-if="editedItem.Tipo == 10" cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Documento"
          :items="ArrayDocumento"
          :item-title="
            (ArrayDocumento) =>
              ArrayDocumento.DocumentoID + '-' + ArrayDocumento.Descripcion
          "
          item-value="DocumentoID"
          color="primary"
          label="Documento Unico:"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Validación Estandár: -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.ValidacionEstandar"
          :items="ArraySiNo"
          :item-title="
            (ArraySiNo) => ArraySiNo.Valor + '-' + ArraySiNo.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Validación estandár:"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Dato Dependiente -->
      <v-col cols="4" sm="4" md="4">
        <v-autocomplete
          v-model="editedItem.DatoDependiente"
          :items="ArrayDatoDependiente"
          :item-title="
            (ArrayDatoDependiente) =>
              ArrayDatoDependiente.Codigo +
              '-' +
              ArrayDatoDependiente.Descripcion
          "
          item-value="Codigo"
          color="primary"
          label="Dato Dependiente:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Protegido DP -->
      <v-col cols="4" sm="4" md="4">
        <v-autocomplete
          v-model="editedItem.ProtegidoDP"
          :items="ArraySiNo"
          :item-title="
            (ArraySiNo) => ArraySiNo.Valor + '-' + ArraySiNo.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Protegido Dato Dependiente:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Visible DP -->
      <v-col cols="4" sm="4" md="4">
        <v-autocomplete
          v-model="editedItem.VisibleDP"
          :items="ArraySiNo"
          :item-title="
            (ArraySiNo) => ArraySiNo.Valor + '-' + ArraySiNo.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Visible Dato Dependiente:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Dato interface -->
      <v-col cols="12" sm="4" md="4">
        <v-autocomplete
          v-model="editedItem.DatoInterface"
          :items="ArraySiNo"
          :item-title="
            (ArraySiNo) => ArraySiNo.Valor + '-' + ArraySiNo.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Dato Interface:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Seguimiento Auditoría -->
      <v-col cols="12" sm="4" md="4">
        <v-autocomplete
          v-model="editedItem.SeguimientoAuditoria"
          :items="ArraySiNo"
          :item-title="
            (ArraySiNo) => ArraySiNo.Valor + '-' + ArraySiNo.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Seguimiento Auditoría:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Dato Decisión -->
      <v-col cols="12" sm="4" md="4">
        <v-autocomplete
          v-model="editedItem.DatoDecision"
          :items="ArraySiNo"
          :item-title="
            (ArraySiNo) => ArraySiNo.Valor + '-' + ArraySiNo.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Dato Decisión:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Calificación Mínima -->
      <v-col cols="4" sm="4" md="4">
        <v-text-field
          v-model="editedItem.CalificacionMinima"
          label="Calificación Mínima:"
          clearable
          dense
          maxlength="5"
          counter="5"
          type="tel"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Calificación Máxima -->
      <v-col cols="4" sm="4" md="4">
        <v-text-field
          v-model="editedItem.CalificacionMaxima"
          label="Calificación Máxima:"
          clearable
          dense
          maxlength="5"
          counter="5"
          type="tel"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Peso -->
      <v-col cols="4" sm="4" md="4">
        <v-text-field
          v-model="editedItem.Peso"
          label="Peso:"
          clearable
          dense
          maxlength="5"
          counter="5"
          type="tel"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Evaluacion Tabla -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.EvalSiNoEstaRangoTabla"
          :items="ArraySiNo"
          :item-title="
            (ArraySiNo) => ArraySiNo.Valor + '-' + ArraySiNo.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Evaluación Tabla:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Causales -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.CausalNegacion"
          :items="ArrayCausalNegacion"
          :item-title="
            (ArrayCausalNegacion) =>
              ArrayCausalNegacion.Codigo + '-' + ArrayCausalNegacion.Descripcion
          "
          item-value="Codigo"
          color="primary"
          label="Causal de Negación:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Campo Relacionado -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.CampoRelacionado"
          :items="
            ArrayCampoRelacionado.map((x) => ({
              ...x,
              Valor: Number(x.Valor),
            }))
          "
          :item-title="
            (ArrayCampoRelacionado) =>
              ArrayCampoRelacionado.Valor +
              '-' +
              ArrayCampoRelacionado.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Campo Relacionado:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span
          >Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span
        >
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn
        size="x-large"
        v-if="!buttonSave"
        color="green"
        text
        @click="ValidateCampos"
      >
        Guardar
      </v-btn>
    </div>
  </v-form>

  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  putDatos,
  postDatos,
  getAllDatos,
} from "@/views/TCI/ProcesosP/Datos/DatosService";
export default {
  name: "datos-registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    infollaves: {
      type: Object,
      default: null,
      Description: "Información de llaves",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "LLamado a Página Iframe",
    },
    componenteview: {
      type: Number,
      default: 0,
      Description: "Saber a que página llamar",
    },
    iconodialogbtn: {
      type: String,
      default: null,
      Description: "Información icono iframe",
    },
    titledialogbtn: {
      type: String,
      default: null,
      Description: "Información titulo iframe",
    },
    Exito: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
  },
  data() {
    return {
      progreso: false,
      componenteview: 0,
      buttonSave: false,
      editedItem: {
        Codigo: 0,
        Descripcion: null,
        Label: null,
        CodigoAyuda: null,
        MensajeError: null,
        Naturaleza: null,
        Tamano: null,
        TamanoCampo: null,
        Obligatoriedad: null,
        Tipo: null,
        TablaValoracion: null,
        ValidacionEstandar: null,
        NombreAPI: null,
        NumeroPredefinida: null,
        NumeroConstante: null,
        NumeroConsecutivo: null,
        DatoDependiente: null,
        ProtegidoDP: null,
        VisibleDP: null,
        ReporteID: null,
        Orden: null,
        DatoInterface: null,
        Grupo: null,
        Documento: null,
        SeguimientoAuditoria: null,
        DatoDecision: null,
        CalificacionMinima: null,
        CalificacionMaxima: null,
        Peso: null,
        EvalSiNoEstaRangoTabla: null,
        CausalNegacion: null,
        CampoRelacionado: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      defaultItem: {
        Codigo: 0,
        Descripcion: null,
        Label: null,
        CodigoAyuda: null,
        MensajeError: null,
        Naturaleza: null,
        Tamano: null,
        TamanoCampo: null,
        Obligatoriedad: null,
        Tipo: null,
        TablaValoracion: null,
        ValidacionEstandar: null,
        NombreAPI: null,
        NumeroPredefinida: null,
        NumeroConstante: null,
        NumeroConsecutivo: null,
        DatoDependiente: null,
        ProtegidoDP: null,
        VisibleDP: null,
        ReporteID: null,
        Orden: null,
        DatoInterface: null,
        Grupo: null,
        Documento: null,
        SeguimientoAuditoria: null,
        DatoDecision: null,
        CalificacionMinima: null,
        CalificacionMaxima: null,
        Peso: null,
        EvalSiNoEstaRangoTabla: null,
        CausalNegacion: null,
        CampoRelacionado: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      ArrayCodigoAyuda: [],
      ArrayMensajeError: [],
      ArrayNaturaleza: [],
      ArraySiNo: [],
      ArrayTipo: [],
      ArrayTablaValoracion: [],
      ArrayNumeroPredefinida: [],
      ArrayNumeroConstante: [],
      ArrayNumeroConsecutivo: [],
      ArrayDatoDependiente: [],
      ArrayReporteID: [],
      ArrayGrupo: [],
      ArrayDocumento: [],
      ArrayCausalNegacion: [],
      ArrayCampoRelacionado: [],
    };
  },
  methods: {
    // Convertir a numero
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      console.log(this.editedItem);
      if (
        this.editedItem.Descripcion == "" ||
        this.editedItem.Descripcion == null ||
        this.editedItem.Label == "" ||
        this.editedItem.Label == null ||
        this.editedItem.CodigoAyuda == "" ||
        this.editedItem.CodigoAyuda == null ||
        this.editedItem.MensajeError == "" ||
        this.editedItem.MensajeError == null ||
        this.editedItem.Naturaleza == "" ||
        this.editedItem.Naturaleza == null ||
        this.editedItem.TamanoCampo == 0 ||
        this.editedItem.TamanoCampo == null ||
        this.editedItem.Obligatoriedad == 0 ||
        this.editedItem.Obligatoriedad == null ||
        this.editedItem.Tipo == 0 ||
        this.editedItem.Tipo == null
      ) {
        validate = true;
      } else if (
        this.editedItem.Tipo == 2 &&
        (this.editedItem.TablaValoracion == 0 ||
          this.editedItem.TablaValoracion == null)
      ) {
        validate = true;
      } else if (
        this.editedItem.Tipo == 4 &&
        (this.editedItem.NombreAPI == "" || this.editedItem.NombreAPI == null)
      ) {
        validate = true;
      } else if (
        this.editedItem.Tipo == 5 &&
        (this.editedItem.NumeroPredefinida == 0 ||
          this.editedItem.NumeroPredefinida == null)
      ) {
        validate = true;
      } else if (
        this.editedItem.Tipo == 8 &&
        (this.editedItem.NumeroConstante == 0 ||
          this.editedItem.NumeroConstante == null)
      ) {
        validate = true;
      } else if (
        this.editedItem.Tipo == 6 &&
        (this.editedItem.NumeroConsecutivo == 0 ||
          this.editedItem.NumeroConsecutivo == null)
      ) {
        validate = true;
      }

      // Consultas a Ejecutar
      if (!validate) {
        var userperfil = this.$store.getters.userperfil;
        this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
        this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;

        if (this.editedIndex != -1) {
          this.putRegistro();
        } else {
          this.postRegistro();
        }
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
      }
    },

    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      try {
        const result = await postDatos(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje ||
          registro.ExceptionMessage ||
          JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      try {
        const result = await putDatos(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje ||
          registro.ExceptionMessage ||
          JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Consulta Datos
    async getDatos() {
      this.ArrayDatoDependiente = [];
      const result = await getAllDatos();
      this.ArrayDatoDependiente = result;
    },

    // Consulta Consecutivos
    async getConsecutivos() {
      this.ArrayNumeroConsecutivo = [];
      this.axios
        .get("/Parametros/Consecutivos/GetAll")
        .then((response) => {
          this.ArrayNumeroConsecutivo = response.data;
        })
        .catch((e) => console.log(e));
    },

    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },

    ChangeTipoDato() {
      this.editedItem.NombreAPI = null;
      this.editedItem.TablaValoracion = null;
      this.editedItem.NumeroPredefinida = null;
      this.editedItem.NumeroConstante = null;
      this.editedItem.NumeroConsecutivo = null;
      this.editedItem.ReporteID = null;
      this.editedItem.Orden = null;
      this.editedItem.Grupo = null;
      this.editedItem.Documento = null;
      this.ArrayTablaValoracion = [];

      if (
        (this.editedItem.Tipo == 2 || this.editedItem.Tipo == 3) &&
        this.editedItem.Naturaleza == "N"
      ) {
        this.ArrayTablaValoracion = this.$store.getters.MTablaNumerico;
      } else if (
        (this.editedItem.Tipo == 2 || this.editedItem.Tipo == 3) &&
        this.editedItem.Naturaleza != "N"
      ) {
        this.ArrayTablaValoracion = this.$store.getters.MTablaAlfaNumerico;
      }
    },

    // Cargue Combos
    CargueCombos() {
      this.getDatos();
      this.getConsecutivos();

      var Tables = this.$store.getters.MTablaSeleccion;

      this.ArraySiNo = Tables.filter(
        (item) => item.Valor != null && item.TablaId == 16,
      );

      this.ArrayTipo = Tables.filter(
        (item) => item.Valor != null && item.TablaId == 76,
      );

      this.ArrayNaturaleza = Tables.filter(
        (item) => item.Valor != null && item.TablaId == 75,
      );

      this.ArrayNumeroPredefinida = Tables.filter(
        (item) => item.Valor != null && item.TablaId == 77,
      );

      this.ArrayCampoRelacionado = Tables.filter(
        (item) => item.Valor != null && item.TablaId == 78,
      );

      this.ArrayGrupo = this.$store.getters.MGrupoDocumentos;
      this.ArrayDocumento = this.$store.getters.MDocumentos;
      this.ArrayCodigoAyuda = this.$store.getters.MCodigoAyuda;
      this.ArrayMensajeError = this.$store.getters.MMessageError;
      this.ArrayCausalNegacion = this.$store.getters.MCausal;
      this.ArrayNumeroConstante = this.$store.getters.MConstantes;
      this.ArrayReporteID = this.$store.getters.MReportes;
    },

    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
      }
    },
  },
  mounted() {
    this.CargueCombos();
    this.ActualizarCargue();
  },
};
</script>
